/**
 * The phone's top lane (07 Workshop, rows 19, 55 and 56; Bar / Top · Phone):
 * a glass capsule on the left (the menu and where you are, or the way back)
 * and one round glass button on the right for the page's own action.
 */
import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

type Props = {
  icon: LucideIcon;
  label: string;
  onCapsule: () => void;
  capsuleLabel?: string;
  action?: { icon: LucideIcon; label: string; onPress: () => void } | null;
  children?: ReactNode;
};

export default function WorkshopLane({ icon: Icon, label, onCapsule, capsuleLabel, action, children }: Props) {
  return (
    <header className="ws-lane">
      <button type="button" className="ws-lane-capsule" onClick={onCapsule} aria-label={capsuleLabel}>
        <Icon aria-hidden="true" />
        <span className="ws-lane-title">{label}</span>
      </button>
      {children}
      {action ? (
        <button type="button" className="ws-lane-round" onClick={action.onPress} aria-label={action.label}>
          <action.icon aria-hidden="true" />
        </button>
      ) : null}
    </header>
  );
}
